import { createContext } from 'react';

export const FilterContext = createContext( null );

export const updateStateFromData = ( state, filterName, selectedOption ) => {

    const filterStateObj = {};

    filterStateObj[ filterName ] = selectedOption;
    const newFilterOptions = Object.assign( state.currentFilterOptions, filterStateObj );

    return { currentFilterOptions: newFilterOptions };

};
